import {
  faCheckCircle,
  faCircleNotch,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { signupFormStore } from '../store/signup-form-reducer.jsx';
import CustomTextInputField from '../components/common/custom-text-input-field/custom-text-input-field.jsx';
import useDiscountCode from '../hooks/useDiscountCode.jsx';

import styles from './discount-form.module.scss';

const DiscountStatusAdornment = ({ loading, coupon, error }) => {
  if (loading) {
    return <FontAwesomeIcon icon={faCircleNotch} spin />;
  }

  if (error) {
    return <FontAwesomeIcon icon={faTimesCircle} color="#DC2626" />;
  }

  if (!coupon) {
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={coupon.isValid ? faCheckCircle : faTimesCircle}
      color={coupon.isValid ? '#22C55E' : '#DC2626'}
      title={coupon.discountString}
    />
  );
};

const DiscountForm = () => {
  const [discountCode, setDiscountCode] = React.useState('');
  const { dispatch } = React.useContext(signupFormStore);
  const { coupon, loading, error } = useDiscountCode(discountCode);

  const handleDiscountCodeChange = event => {
    setDiscountCode(event.target.value);
  };

  React.useEffect(() => {
    if (coupon?.isValid) {
      dispatch({ type: 'UPDATE_DISCOUNT_CODE', payload: discountCode });
    } else {
      dispatch({ type: 'UPDATE_DISCOUNT_CODE', payload: '' });
    }
  }, [coupon, dispatch]);

  return (
    <div className={styles.discountForm}>
      <CustomTextInputField
        label="Coupon Code"
        value={discountCode}
        onChange={handleDiscountCodeChange}
        testid={'discount-code'}
        fullWidth
        endAdornment={
          <DiscountStatusAdornment
            loading={loading}
            coupon={coupon}
            error={error}
          />
        }
        helperText={coupon?.discountString}
      />
    </div>
  );
};

export default DiscountForm;
